export default class Nav {

    constructor() {
        this.resizeWindow();
        this.mobileNav();

        window.addEventListener('load', e => {
            this.fixOnScroll();
        });
    }

    resizeWindow() {
        let resizeTimer;
        window.addEventListener('resize', e => {
            if (resizeTimer) clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                this.mobileNav();
                this.fixOnScroll();
            }, 100, e);
        });
    }

    fixOnScroll() {
        const nvm = document.querySelector('.nvm');
        const handleScroll = function () {
            if (this.scrollY > 44) {
                document.body.classList.add('nav-fixed');
                // nvm.style.top = '35%';
                // nvm.style.right = '35%';
            } else {
                document.body.classList.remove('nav-fixed');
                // nvm.style.top = '60%';
                // nvm.style.right = '20%';
            }
        };
        if (window.innerWidth >= 992 && (document.body.offsetHeight - window.innerHeight) >= 1) {
            window.addEventListener('scroll', handleScroll);
        } else {
            window.removeEventListener('scroll', handleScroll);
            document.body.classList.remove('nav-fixed');
        }
    }

    mobileNav() {
        if (window.innerWidth < 992) {
            const burger = document.querySelector('header .burger');

            // Remove old listener and add new one to prevent duplicates
            burger.removeEventListener('click', this.handleClick);
            burger.addEventListener('click', this.handleClick);

            // Find all links with submenus in the header
            const menuItems = document.querySelectorAll('header nav ul > li');

            // Clear all previous listeners by cloning and replacing elements
            menuItems.forEach(li => {
                const link = li.querySelector('a');
                const submenu = li.querySelector('ul');

                // Only process items with submenus
                if (link && submenu) {
                    // Clone the link to remove all event listeners
                    const newLink = link.cloneNode(true);
                    link.parentNode.replaceChild(newLink, link);

                    // Add new click handler
                    newLink.addEventListener('click', e => {
                        e.preventDefault();

                        // If already open, close it
                        if (li.classList.contains('open')) {
                            li.classList.remove('open');
                            newLink.classList.remove('open');
                        } else {
                            // Close all other open menus
                            menuItems.forEach(item => {
                                item.classList.remove('open');
                                const itemLink = item.querySelector('a');
                                if (itemLink) itemLink.classList.remove('open');
                            });

                            // Open this one
                            li.classList.add('open');
                            newLink.classList.add('open');
                        }
                    });
                }
            });

            // Set active class if needed
            const activeLink = document.querySelector('header nav a.active');
            if (activeLink) {
                const activeLi = activeLink.closest('li');
                if (activeLi) activeLi.classList.add('active');
            }
        } else {
            // Desktop behavior
            document.body.classList.remove('nav-open');

            const menuItems = document.querySelectorAll('header nav ul li');
            menuItems.forEach(li => {
                const submenu = li.querySelector('ul');
                if (submenu) {
                    const link = li.querySelector('a');
                    if (link) {
                        link.addEventListener('touchstart', e => {
                            const style = window.getComputedStyle(submenu);
                            if (style.maxHeight === '0px') {
                                e.preventDefault();
                            }
                        });
                    }
                }
            });
        }
    }

    handleClick(e) {
        e.preventDefault();
        document.body.classList.toggle('nav-open');
    };
}
